const TeacherBookDic = {
    'tryoClass': {
        'fa': 'کلاس آزمایشی',
    },
    'reserve': {
        'fa': 'رزرو کلاس',
    },
}
export default TeacherBookDic